/**
 * Represents validation error codes for NDC Destination import rows.
 */
export enum NdcDestinationValidationErrorCodeModel {
	/**
	 * The NDC value is missing.
	 */
	NdcRequired = 11,
	/**
	 * The NDC value has an invalid format.
	 */
	NdcFormat = 12,
	/**
	 * The Rebate Group value is missing.
	 */
	RebateGroupRequired = 21,
	/**
	 * The specified Rebate Group was not found.
	 */
	RebateGroupNotFound = 22,
	/**
	 * The Rebate Aggregator value is missing.
	 */
	RebateAggregatorRequired = 31,
	/**
	 * The specified Rebate Aggregator was not found.
	 */
	RebateAggregatorNotFound = 32,
	/**
	 * The Effective Date value is missing.
	 */
	EffectiveDateRequired = 41,
	/**
	 * The Effective Date has an invalid format.
	 */
	EffectiveDateFormat = 42,
	/**
	 * The Effective Date cannot be in the past for Add operations.
	 */
	EffectiveDateMustNotBeInThePast = 43,
	/**
	 * The Termination Date has an invalid format.
	 */
	TerminationDateFormat = 51,
	/**
	 * The Termination Date must be greater than the Effective Date.
	 */
	TerminationDateMustBeGreaterThanEffectiveDate = 52,
	/**
	 * The Action value is missing.
	 */
	ActionRequired = 61,
	/**
	 * The Action must be either "Add" or "Update".
	 */
	ActionMustBeAddOrUpdate = 62,
	/**
	 * No matching record was found for the Update operation.
	 */
	RecordForUpdateNotFound = 71,
	/**
	 * Update operation is not allowed for a terminated record.
	 */
	UpdateNotAllowedForTerminatedRecord = 72,
	/**
	 * The date ranges in the file contain overlapping periods.
	 */
	DateRangeOverlapInFile = 81
}
